import localStore from '@src/utils/storage';
import axios from 'axios';

const langkey = '__languages',
      langurl = '/languages.json' ;
  

const storeLangs = async ( codes ) =>{
    try{    
        const { data: langData } = await axios.get( langurl ) ;
        if( !Array.isArray( langData ) )return [] ;
        const languages = langData
            .map( lang => ( {
                lang: lang[ 'English' ],
                code: lang[ 'alpha3-b' ],
                shortcode: lang[ 'alpha2' ]
            } ) )
            .filter( lang => codes.includes( lang.code ) );
        
        localStore.set( langkey, languages );
        return languages ;
    }
    catch{ 
        return [] ;
    }
}

const getLangs = async ( codes ) => {
    if( !Array.isArray( codes ) )return [] ;
    if( !codes.includes( 'eng' ) )codes.unshift( 'eng' );
    const localdata = localStore.get( langkey );
    if( !Array.isArray( localdata ) )return storeLangs( codes ) ;

    const availablecodes = localdata.map( lang => lang.code );
    return ( 
            codes.every( code => availablecodes.includes( code ) ) && 
            ( codes.length === availablecodes.length )
            ) ? localdata : storeLangs( codes ) ;
}

export default getLangs ;